<template>
  <TheGreyWrapper>
    <BaseSection
      v-if="opportunity"
      class="pt-6"
    >
      <BaseTitleGroup
        :subtitle="opportunity.data.attributes.name"
        :title="$t('Confirmation')"
        class="mb-4"
      />
      <BaseParagraph class="text-grey mb-8">
        {{ $t('Wish confirmation') }}
        <br><br>
        {{ $t("We'll get back to you") }}
      </BaseParagraph>
      <div class="flex items-center justify-center mb-8">
        <img
          src="../assets/Kerala_tree.gif"
          alt="Invest success"
          class="success-image"
        >
      </div>
      <BaseButton
        :title="$t('Back to home')"
        to="/opportunities"
        class="md:mb-12"
        @click="onButtonClick"
      />
    </BaseSection>
  </TheGreyWrapper>
</template>

<script>
import loadOpportunity from '../mixins/loadOpportunity';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseParagraph from '../components/BaseParagraph.vue';
import BaseButton from '../components/BaseButton.vue';
import TheGreyWrapper from '../components/TheGreyWrapper.vue';
import { ACKNOWLEDGED_WISH_CONFIRMATION } from '../analytics';
import { SET_OPPORTUNITY_SHOW } from '../store/mutation-types';

export default {
  name: 'WishConfirmation',
  components: {
    BaseSection,
    BaseTitleGroup,
    BaseParagraph,
    BaseButton,
    TheGreyWrapper,
  },
  mixins: [loadOpportunity],
  methods: {
    onButtonClick() {
      analytics.track(ACKNOWLEDGED_WISH_CONFIRMATION);
      this.$store.commit(SET_OPPORTUNITY_SHOW, null);
    },
  },
};
</script>

<style lang="css" scoped>
.success-image {
  max-width: 220px;
}
</style>
